<article
  class="[&::before]:from-blue-sapphire [&::after]:bg-blue-neon-glacier relative h-200 w-full overflow-hidden rounded-3xl bg-[url('https://superlikers-themes.s3.us-east-1.amazonaws.com/tonicorp/assets/conductor.png')] bg-cover bg-center bg-no-repeat [&::after]:absolute [&::after]:top-1/3 [&::after]:right-0 [&::after]:h-50 [&::after]:w-50 [&::after]:rounded-full [&::after]:opacity-40 [&::after]:blur-3xl [&::after]:content-[''] [&::before]:absolute [&::before]:inset-0 [&::before]:z-0 [&::before]:bg-gradient-to-b [&::before]:to-transparent [&::before]:content-['']">
  <div class="relative flex flex-col items-center space-y-4 px-4 py-8 text-center">
    <div class="relative flex h-32 w-90 items-end justify-center">
      <img
        src="https://superlikers-themes.s3.us-east-1.amazonaws.com/tonicorp/background_logo_contador.webp"
        alt="Decoración"
        class="pointer-events-none absolute bottom-0 left-1/2 z-0 h-10 w-full -translate-x-1/2 select-none" />
      <img
        src="https://superlikers-themes.s3.us-east-1.amazonaws.com/tonicorp/logo.webp"
        alt="Fórmula Tonicorp"
        class="relative z-10 h-full w-full object-contain" />
    </div>
    <h1 class="text-blue-neon-glacier text-5xl font-bold tracking-wide uppercase italic drop-shadow-[0_0_6px_#00ccf0]">
      ¡TU MOTOR YA ESTÁ!
    </h1>
    <div class="relative flex items-center justify-center">
      <img
        src="https://superlikers-themes.s3.us-east-1.amazonaws.com/tonicorp/lights_logo_contador.webp"
        alt="Decoración"
        class="pointer-events-none absolute right-50 h-8 rotate-180 select-none" />

      <h2 class="z-10 text-5xl font-extrabold tracking-wide text-white uppercase italic drop-shadow-[0_0_6px_white]">
        ENCENDIDO!
      </h2>
      <img
        src="https://superlikers-themes.s3.us-east-1.amazonaws.com/tonicorp/lights_logo_contador.webp"
        alt="Decoración"
        class="pointer-events-none absolute left-50 h-8 select-none" />
    </div>
    <p class="max-w-md text-lg leading-5 font-bold text-blue-100">
      <span class="text-blue-neon-glacier">Próximamente:</span>
      {{ text() }}
    </p>
    <span class="text-blue-neon-glacier text-2xl font-semibold">¡LO MEJOR ESTÁ POR VENIR!</span>
  </div>
</article>
